import {isEditorShortcutBlocked} from './shortcut-event';

/** Use the visible host-save action, never upstream browser-local persistence. */
export function handleWorkSaveShortcut(event: Pick<KeyboardEvent, 'metaKey'|'ctrlKey'|'altKey'|'shiftKey'|'key'|'target'|'type'|'defaultPrevented'|'isComposing'|'repeat'|'preventDefault'>, button: Pick<HTMLButtonElement, 'disabled' | 'click'> | null): void {
  if (!(event.metaKey || event.ctrlKey) || event.altKey || event.shiftKey || event.key.toLowerCase() !== 's') return;
  if (isEditorShortcutBlocked(event)) return;
  event.preventDefault();
  if (!event.repeat && button && !button.disabled) button.click();
}
